import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttachedDataSelectorComponent } from './components/attached-data-selector/attached-data-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { BaseSelectorModule } from '../base-selector/base-selector.module';
import { AttachedDataValueInputComponent } from './components/attached-data-value-input/attached-data-value-input.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginatorModule } from '@angular/material/paginator';

export { AttachedDataSelectorComponent } from './components/attached-data-selector/attached-data-selector.component';
export { AttachedDataValueInputComponent } from './components/attached-data-value-input/attached-data-value-input.component';

@NgModule({
  declarations: [AttachedDataSelectorComponent, AttachedDataValueInputComponent],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgSelectModule,
    MatPaginatorModule,
    BaseSelectorModule,
    NgbTooltipModule,
  ],
  exports: [AttachedDataSelectorComponent, AttachedDataValueInputComponent],
})
export class AttachedDataSelectorModule {}
